module.exports = __webpack_public_path__ + "media/customizations/sundancenorthlife/logo-077ce451aa402136598552352d9434f7.png";